import tw from "tailwind-styled-components";

export const Page = tw.section`py-24 md:pt-28 pb-14`;
export const Bg = tw.section`flex  items-center py-24 md:pt-28 pb-14`
// export const BoxContainer = tw.div`Container md:rounded-md md:border md:shadow-md md:p-8 `;
// export const BoxContainer = tw.div`Container md:mt-4 md:p-4`;
export const BoxContainer = tw.div`Container py-6`;
export const BoxHead = tw.div`flex flex-col md:flex-row justify-between md:items-center mb-4 mx-auto gap-4`;
//export const BoxTitle = tw.h1`text-xl  text-gray-700 font-medium inline-flex space-x-2 items-center   cursor-pointer `;
export const BoxTitle = tw.h1`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-xl  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;
export const BoxSubTitle = tw.h3`mt-1 ml-1 sm:mt-2 lg:mt-3   text-gray-500 text-sm lg:text-base `;
export const ErrorText = tw.p`my-20 text-red-600 text-sm text-center`;
export const Button = tw.button`
 text-white bg-primary-color transition hover:bg-sky-700  flex items-center justify-center w-40   h-10 text-xs  whitespace-nowrap rounded sm:px-6 px-2
`;
export const OutlineButton = tw.button`
 text-primary-color border border-primary-color bg-white transition hover:bg-primary-color hover:text-white flex items-center justify-center w-40   h-10 text-xs  whitespace-nowrap rounded sm:px-6 px-2
`;
export const PrevBtn = tw.div`w-8  h-8 rounded-full cursor-pointer disabled:opacity-25 disabled:cursor-not-allowed  text-sm  border border-gray-300 text-gray-300 hover:text-gray-700 hover:border-gray-700 flex justify-center items-center  `;

export const NextBtn = tw.div`w-8  h-8 rounded-full cursor-pointer disabled:opacity-25 disabled:cursor-not-allowed text-sm  border border-gray-300 text-gray-300 hover:text-gray-700 hover:border-gray-700  flex justify-center items-center  `;

export const PaginationWrapper = tw.div`flex mt-5 justify-end gap-3 items-center text-sm text-gray-400 mr-2 mb-2`;
export const Underline = tw.div`w-12 h-0.5 bg-black mt-1.5 rounded-full `;
export const UserImage = tw.img`w-9 h-9 rounded-full `;
export const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 p-4`;
export const UserInfo = tw.div`flex flex-col`;
export const FilterTableWrapper = tw.div`rounded-lg py-4 border mt-4 bg-white`;
export const FilterWrapper = tw.div`flex w-full flex-col md:flex-row xl:gap-0 gap-4 lg:space-x-4 px-4 md:items-center md:justify-between`;
export const FilterWrapperWithSearch = tw.div`w-full flex flex-wrap px-4 gap-4 items-center justify-between xl:flex-nowrap`;
export const MenuOptions = tw.div`
  absolute bottom-10 right-0
  py-2 w-max
  bg-white z-50
  rounded-xl
  shadow-xl
  border border-gray-200
  flex flex-col
`;
export const MenuItem = tw.div`flex items-center gap-2 
  px-4 py-2 
  text-sm 
  cursor-pointer 
  hover:bg-gray-50`;

export const Btn = tw.button`
  action-btn
  grid place-items-center
  w-8 h-8
  rounded-full
  hover:bg-gray-100
  transition
`;

export const FloorTabs = tw.div`flex gap-6 overflow-x-auto no-scrollbar`;

export const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
   px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;

export const DownloadBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-primary-color/5 hover:shadow-md h-full py-2.5 text-sm`;